// UX-060: tab-badge counts are decoration. A 404 from a count request means
// "none" (an older backend that does not know the address), not an error, and
// is never retried — a retry is only a second failed request in the log.
const statusOf = (err: unknown): number | undefined =>
  (err as { response?: { status?: number } } | null)?.response?.status

export async function countOrNone<T extends { count: number }>(load: () => Promise<T>, none: T): Promise<T> {
  try {
    return await load()
  } catch (err) {
    if (statusOf(err) === 404) return none
    throw err
  }
}

export const noRetryOn404 = (failureCount: number, err: unknown): boolean =>
  statusOf(err) !== 404 && failureCount < 1
